<div class="header-logo d-flex align-items-center" (click)="n.go(Config.MAIN_VIEW)" #el>
  <img draggable="false" src="/assets/img/logo-white.svg" [alt]="'projectName' | translate" />
</div>
